import { render, staticRenderFns } from "./AutoApproveDialog.vue?vue&type=template&id=ace2d03a&scoped=true"
import script from "./AutoApproveDialog.vue?vue&type=script&lang=js"
export * from "./AutoApproveDialog.vue?vue&type=script&lang=js"
import style0 from "./AutoApproveDialog.vue?vue&type=style&index=0&id=ace2d03a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace2d03a",
  null
  
)

export default component.exports